{
  "codexEntityForm": {
    "character": "キャラクター",
    "place": "場所",
    "faction": "勢力",
    "object": "物",
    "concept": "概念",
    "editName": "{{name}}を編集",
    "newCodexEntry": "新しい設定集の項目",
    "theWorldHasChangedTheDraft": "世界観が変更されました。下書きは保持されています。保存する前に項目を再読み込みしてください。",
    "portraitChooseAnImage": "肖像：画像を選択",
    "change": "変更",
    "addPortrait": "肖像を追加",
    "portraitImage": "肖像の画像",
    "entryName": "項目の名前",
    "name": "名前",
    "entryType": "項目の種類",
    "customCategory": "カスタムカテゴリー",
    "categoryEGDeityShipSpell": "カテゴリー（例：神格、船、呪文）",
    "aliases": "別名",
    "entryAliases": "項目の別名",
    "otherNamesOneAtATime": "ほかの名前を一つずつ…",
    "tags": "タグ",
    "entryTags": "項目のタグ",
    "themesRolesArcs": "テーマ、役割、成長…",
    "collection": "コレクション",
    "entryCollection": "項目のコレクション",
    "noCustomCollection": "カスタムコレクションなし",
    "folder": "フォルダー",
    "entryFolder": "項目のフォルダー",
    "unfiled": "未分類",
    "notes": "ノート",
    "entryNotes": "項目のノート",
    "whoTheyAreWhatTheyWant": "どんな人物か、何を望むか、読者に早く知られてはならないこと…",
    "entryFields": "項目のフィールド",
    "fields": "フィールド",
    "fieldTemplate": "フィールドのテンプレート",
    "template": "テンプレート…",
    "schemaOf": "スキーマ：",
    "addMissingFields": "不足しているフィールドを追加",
    "addField": "フィールドを追加",
    "noCustomFieldYetFieldsGive": "カスタムフィールドはまだありません。フィールドは、年齢、忠誠、秘密など、チェックが推論できる構造化された事実を項目に与えます。",
    "sharedFieldNamesTypesAndOptions": "共有フィールドの名前、型、選択肢は、コレクションの設定で管理します。値はこのページに属します。",
    "fieldNameN": "フィールド名{{n}}",
    "fieldName": "フィールド名",
    "fieldTypeN": "フィールドの型{{n}}",
    "unknown": "不明",
    "fieldValueN": "フィールドの値{{n}}",
    "select": "選択…",
    "yes": "はい",
    "no": "いいえ",
    "value": "値",
    "chooseAnEntry": "項目を選択…",
    "eGSpringOfYear12": "例：12年目の春、または包囲の日",
    "below": "下",
    "unknownValueN": "不明な値{{n}}",
    "required": "必須",
    "sharedField": "共有フィールド",
    "remove": "削除",
    "confirmRemoval": "削除を確認",
    "paragraph": "段落",
    "aFewLines": "数行…",
    "discardTheDraft": "下書きを破棄しますか？",
    "confirmReload": "再読み込みを確認",
    "keepEditing": "編集を続ける",
    "reloadEntry": "項目を再読み込み",
    "cancel": "キャンセル",
    "chooseAnImageFileForThe": "肖像に使う画像ファイルを選んでください。",
    "thePortraitMustBeUnder8": "肖像は8MiB未満にしてください。",
    "saveEntry": "項目を保存",
    "searchEntries": "項目を検索…"
  },
  "codexEntryDialog": {
    "newCodexEntry": "新しい設定集の項目",
    "savedToWorldCodexTheManuscript": "世界観 › 設定集に保存しました。原稿では、入力していた場所で言及されます。",
    "createAndMention": "作成して言及"
  },
  "continuityPanel": {
    "relationsOverTime": "時間経過での関係",
    "checkingRelations": "関係を確認しています…",
    "cancel": "キャンセル",
    "theProjectHasChangedRunThe": "この実行の後に、原稿または世界観が変更されました。チェックをもう一度実行して、関係を更新してください。",
    "anAnalysisLimitWasReachedThe": "分析の上限に達しました。結果は部分的です。",
    "ruleApplied": "ルール：「{{label}}」、{{rule}}。",
    "oneSourcePerTarget": "各対象に一つの起点",
    "oneTargetPerSource": "各起点に一つの対象",
    "interval": "{{start}}から{{end}}まで",
    "openScene": "{{scene}}を開く",
    "findingReferenceMissing": "もう存在しない項目を指しています。",
    "findingConfirmedWithoutEvidence": "本文からの引用なしで確認されているため、出典を確認できません。",
    "findingEvidenceMissing": "根拠にしている引用がなくなりました。",
    "findingEvidenceNotCurrent": "根拠にしている引用が未確認か、本文と一致しなくなりました。",
    "findingExclusiveNotEvaluable": "ルールに照らして確認できません。方向、両端、完全な期間が必要です。",
    "findingExclusiveOverlap": "これらのうち二つが同時に成り立っていますが、ルールで認められていません。",
    "findingOther": "この関係に確認すべき点があります。",
    "theProjectExceedsTheLimitOf": "プロジェクトがこの分析の上限を超えています。データは変更されていません。",
    "theAnalysisExceededItsExecutionLimit": "分析が実行の上限を超えました。データは変更されていません。",
    "analysisCancelled": "分析をキャンセルしました。",
    "checksNotCompletedTheTextAnd": "チェックは完了しませんでした。本文と正史は変更されていません。"
  },
  "eventTimelinePanel": {
    "eventHistory": "出来事の履歴",
    "timeline": "年表",
    "newEvent": "新しい出来事",
    "searchEvents": "出来事を検索",
    "searchEvents2": "出来事を検索…",
    "timelineOrder": "年表の順序",
    "storyTime": "物語内の時間",
    "readingOrder": "読む順序",
    "dateStatus": "日付の状態",
    "allDates": "すべての日付",
    "resolvedDates": "解決済みの日付",
    "unresolvedDates": "未解決の日付",
    "filterEventsByScene": "シーンで出来事を絞り込み",
    "allScenes": "すべてのシーン",
    "scenes": "シーン",
    "editEvent": "出来事を編集",
    "closeEventEditor": "出来事エディターを閉じる",
    "theWorldHasChangedReloadThe": "世界観が変更されました。保存する前に出来事を再読み込みしてください。下書きのフィールドは保持されています。",
    "eventTitle": "出来事のタイトル",
    "whatHappens": "何が起きるか",
    "scene": "シーン",
    "eventScene": "出来事のシーン",
    "notLinked": "リンクなし",
    "removedSceneSceneid": "削除されたシーン — {{sceneId}}",
    "dateType": "日付の種類",
    "eventDateType": "出来事の日付の種類",
    "unknown": "不明",
    "definedInterval": "定義された区間",
    "relativeToAnEvent": "出来事に対する相対",
    "start": "開始",
    "eventStart": "出来事の開始",
    "endExclusive": "終了（含まない）",
    "eventEnd": "出来事の終了",
    "referenceEvent": "基準の出来事",
    "select": "選択…",
    "referenceToVerifyAnchoreventid": "確認が必要な参照 — {{anchorEventId}}",
    "events": "出来事",
    "offsetInTicks": "ティックでのずれ",
    "eventOffset": "出来事のずれ",
    "saveEvent": "出来事を保存",
    "closeReload": "閉じる／再読み込み…",
    "discardTheDraftChanges": "下書きの変更を破棄しますか？",
    "discardDraft": "下書きを破棄",
    "reloadEvent": "出来事を再読み込み",
    "keepEditing": "編集を続ける",
    "noEventMatchesTheseFiltersEvents": "これらの条件に一致する出来事はありません。出来事は、チェックが推論する対象です。何がいつ起き、読者がどのシーンでそれを知るか。",
    "tickStart": "ティック{{start}}",
    "openScene": "シーンを開く",
    "editTitle": "{{title}}を編集",
    "removeTitle": "{{title}}を削除",
    "confirmEventRemoval": "出来事の削除を確認",
    "cancel": "キャンセル",
    "theWorldHasChangedCancelAnd": "世界観が変更されました。キャンセルして、確認をもう一度開いてください。",
    "resolvedDate": "解決済みの日付",
    "unknownDate": "不明な日付",
    "missingReference": "参照が見つかりません",
    "timeCycle": "時間の循環",
    "dateOutOfRange": "日付が範囲外",
    "eventsFoundOfTotal_other": "{{count}}件の出来事が見つかりました（全{{total}}件中）",
    "removeThisEventReferences_other": "この出来事を削除しますか？直接の参照{{count}}件を確認する必要があります。",
    "showMoreEvents_other": "さらに{{count}}件の出来事を表示"
  },
  "fieldEditor": {
    "choose": "選択…",
    "labelSearch": "{{label}}の検索",
    "search": "検索…",
    "labelOptions": "{{label}}の選択肢",
    "noMatch": "一致するものはありません。",
    "optionsOnePerLine": "選択肢（1行に1つ）",
    "fieldOptionsIndex": "フィールドの選択肢{{index}}",
    "addOptionIndex": "選択肢{{index}}を追加",
    "newOption": "新しい選択肢",
    "addOption": "選択肢を追加",
    "fieldValueIndex": "フィールドの値{{index}}",
    "chooseOptions": "選択肢を選ぶ…",
    "chooseEntries": "項目を選ぶ…",
    "unsupportedMultiValueEditor": "対応していない複数値エディター"
  },
  "graphExplorer": {
    "relationGraph": "関係グラフ",
    "entry": "項目",
    "filterGraphByEntry": "項目でグラフを絞り込み",
    "all": "すべて",
    "status": "状態",
    "graphRelationStatus": "グラフの関係の状態",
    "proposedAndConfirmed": "提案済みと確認済み",
    "confirmed": "確認済み",
    "proposed": "提案済み",
    "relation": "関係",
    "searchRelationInTheGraph": "グラフ内の関係を検索",
    "filterAtStoryTime": "物語内の時間で絞り込み",
    "tick": "ティック",
    "graphTick": "グラフのティック",
    "includeUnknownTime": "時間不明を含める",
    "enterANumericTickOrTurn": "数値のティックを入力するか、時間フィルターをオフにしてください。",
    "navigableRelationGraph": "操作できる関係グラフ",
    "selectName": "{{name}}を選択",
    "entryCount_other": "{{count}}項目",
    "relationCount_other": "{{count}}件の関係",
    "hiddenBeyondViewLimit": "{{entries}}と{{relations}}が表示上限を超えています。",
    "relationsWithMissingEntries_other": "{{count}}件の関係で項目が欠けています。",
    "unknownDurationIncluded_other": "期間が不明な{{count}}件の関係がフィルターに含まれています。",
    "unknownDurationExcluded_other": "期間が不明な{{count}}件の関係がフィルターに含まれていません。"
  },
  "relationshipPanel": {
    "select": "選択…",
    "removedReference": "削除された参照：",
    "projectRelations": "プロジェクトの関係",
    "relationsOf": "関係：",
    "filterRelationsByEntry": "項目で関係を絞り込み",
    "allEntries": "すべての項目",
    "searchEntries": "項目を検索…",
    "searchRelations": "関係を検索",
    "relationOrEntry": "関係または項目",
    "newRelation": "新しい関係",
    "editRelation": "関係を編集",
    "relationsLinkTwoEntries": "関係は二つの項目を結びます",
    "addTwoEntriesInTheCodex": "設定集に項目を少なくとも二つ追加し、それらを結ぶ言葉を書きましょう。たとえば「の師である」。",
    "theWorldHasChangedTheFields": "開いている間に世界観が変更されました。フィールドは保持されています。新しいデータに対して保存するには、再読み込みしてください。",
    "reload": "再読み込み",
    "anEntry": "ある項目",
    "anotherEntry": "別の項目",
    "relationSource": "関係の起点",
    "relationType": "関係の種類",
    "isTheMentorOf": "の師である",
    "relationTarget": "関係の対象",
    "direction": "方向",
    "relationDirection": "関係の方向",
    "oneWay": "一方向",
    "bothWays": "双方向",
    "when": "いつ",
    "relationTime": "関係の時間",
    "notSet": "未設定",
    "betweenTwoMoments": "二つの時点の間",
    "fromAnEvent": "出来事から",
    "from": "開始：",
    "to": "終了：",
    "relationStart": "関係の開始",
    "relationEnd": "関係の終了",
    "momentsHint": "世界の年表上の時点。終了は含まれません。",
    "event": "出来事",
    "relationEvent": "関係の出来事",
    "offset": "ずれ",
    "relationOffset": "関係のずれ",
    "offsetHint": "出来事の後の時点。前の場合は負の値。",
    "status": "状態",
    "relationStatus": "関係の状態",
    "proposed": "提案済み",
    "confirmed": "確認済み",
    "rejected": "却下",
    "superseded": "置き換え済み",
    "confirmedRelationsCountAsCanonIn": "確認済みの関係は、チェックで正史として扱われます。",
    "notes": "ノート",
    "relationNotes": "関係のノート",
    "howTheStoryShowsItAnd": "物語がそれをどう示すか、何があいまいなままか。",
    "quotes": "引用",
    "linkQuotes": "本文からの引用をリンク",
    "quotesLinked": "引用：{{count}}件",
    "searchQuotations": "引用を検索",
    "excerptOrNote": "抜粋またはメモ",
    "removedQuotation": "削除された引用：",
    "noQuotationYetAnnotateAPassage": "引用はまだありません。原稿の箇所に注釈をつけると、ここで引用できます。",
    "upTo100QuotationsShownUse": "最大100件の引用を表示します。検索で絞り込んでください。",
    "saveRelation": "関係を保存",
    "cancel": "キャンセル",
    "aDeletedEntry": "削除された項目",
    "aDeletedEvent": "削除された出来事",
    "timeBetween": "{{start}}から{{end}}まで",
    "timeAtEvent": "{{event}}の時点",
    "timeAfterEvent": "{{event}} + {{offset}}",
    "timeBeforeEvent": "{{event}} − {{offset}}",
    "noRelationsYet": "関係はまだありません。",
    "noRelationMatches": "一致する関係はありません。",
    "edit": "編集",
    "editCaption": "{{caption}}を編集",
    "remove": "削除",
    "removeCaption": "{{caption}}を削除",
    "removeThisRelationTheChangeStays": "この関係を削除しますか？変更は履歴に残ります。",
    "confirmRemoval": "削除",
    "shownOfTotal": "{{total}}件中100件の関係を表示しています。検索で絞り込むと、ほかも見られます。",
    "theWorldHasChangedReloadThe": "世界観が変更されました。保存する前に関係を再読み込みしてください。",
    "theRelationWasChangedOrRemoved": "関係が変更または削除されました。データを再読み込みしてください。",
    "explicitlyConfirmTheRelationBeforeSaving": "この関係を正史にするには、もう一度「確認済み」を選んでください。",
    "selectTwoEntriesThatExistIn": "設定集にある項目を二つ選んでください。",
    "fillInTheTimeValuesOr": "時点を入力するか、「未設定」を選んでください。",
    "enterAValidIntervalTheEnd": "終了は開始より後にしてください。",
    "selectAnExistingEventAsThe": "まだ存在する出来事を選んでください。",
    "theSelectedQuotationIsNoLonger": "選んだ引用がもう存在しません。",
    "checkTheRelationTextAndThe": "関係の言葉とノートを確認してください。",
    "theChangeWasNotSavedReload": "変更は保存されませんでした。データを再読み込みして、もう一度お試しください。"
  },
  "useWorldReplication": {
    "signInToTheLinkedAccount": "連携したアカウントにサインインし、プロジェクトへのアクセス権を確認してください。ローカルの変更は保持されています。",
    "syncTheManuscriptWithThisServer": "世界観をリンクする前に、原稿をこのサーバーと同期してください。",
    "theWorldChangedAfterTheComparison": "比較の後で世界観が変更されました。現在のコピーをもう一度確認してください。",
    "aConfirmationOrRestoredRecordNeeds": "確認または復元された記録は、同期の前に明示的な確認が必要です。",
    "anAttachmentOrRemoteCopyFailed": "添付またはリモートのコピーの検証に失敗しました。ローカルの世界観は保持されています。",
    "theseChangesExceedASyncLimit": "これらの変更は同期の上限を超えているか、まとめて適用する必要があります。ローカルの世界観と保留中の変更は保持されています。",
    "syncPausedYourLocalChangesAre": "同期を一時停止しました。ローカルの変更は保持されています。",
    "newMapNeedsPlan": "新しい地図はInkとPressで利用できます。地図はこの端末に残り、世界観は待機します。新しい地図を削除するか、プランを選ぶと、再び同期されます。",
    "worldSyncCouldNotFinishCheck": "世界観の同期を完了できませんでした。接続を確認して、もう一度お試しください。ローカルの変更は保持されています。"
  },
  "vaultFolders": {
    "folderName": "フォルダー{{name}}",
    "editFolder": "フォルダーを編集",
    "newSubfolder": "新しいサブフォルダー",
    "moveContentsBeforeRemoving": "削除する前に中身を移動してください",
    "removeFolder": "フォルダーを削除",
    "folderActionsName": "{{name}}フォルダーの操作",
    "chooseThisFolderWhenEditingA": "ページを編集するときに、このフォルダーを選んでください。",
    "projectFolders": "プロジェクトのフォルダー",
    "folders": "フォルダー",
    "newFolder": "新しいフォルダー",
    "groupPagesFromAnyCollection": "どのコレクションのページでもまとめられます。",
    "foldersOrganizePagesWithoutChangingTheir": "フォルダーは、コレクションや内容を変えずにページを整理します。",
    "cancel": "キャンセル",
    "saveFolder": "フォルダーを保存",
    "name": "名前",
    "folderName2": "フォルダー名",
    "inside": "格納先",
    "parentFolder": "親フォルダー",
    "projectRoot": "プロジェクトのルート",
    "removeEmptyFolder": "空のフォルダーを削除しますか？",
    "removeNameFromTheProject": "「{{name}}」をプロジェクトから削除しますか？"
  },
  "vaultTable": {
    "unavailableEntry": "利用できない項目",
    "vaultTable": "ボールトの表",
    "pages": "ページ",
    "searchVaultTable": "ボールトの表を検索",
    "searchPages": "ページを検索…",
    "tableCollection": "表のコレクション",
    "allCollections": "すべてのコレクション",
    "noCustomCollection": "カスタムコレクションなし",
    "tableFolder": "表のフォルダー",
    "allFolders": "すべてのフォルダー",
    "unfiled": "未分類",
    "scrollableVaultTable": "スクロールできるボールトの表",
    "name": "名前",
    "collection": "コレクション",
    "folder": "フォルダー",
    "noPagesMatchTheseFilters": "これらの条件に一致するページはありません。",
    "none": "なし",
    "yes": "はい",
    "no": "いいえ",
    "pagesShown_other": "{{count}}ページ中{{shown}}ページ"
  },
  "vaultTree": {
    "blue": "青",
    "emerald": "エメラルド",
    "gold": "金",
    "violet": "紫",
    "rose": "ローズ",
    "amber": "琥珀",
    "teal": "ティール",
    "slate": "スレート",
    "crimson": "深紅",
    "bark": "樹皮",
    "forest": "森",
    "navy": "ネイビー",
    "orchid": "蘭",
    "saffron": "サフラン",
    "ink": "インク",
    "ember": "燠火",
    "concept": "概念",
    "character": "キャラクター",
    "place": "場所",
    "faction": "勢力",
    "object": "物",
    "vault": "ボールト",
    "newCollection": "新しいコレクション",
    "vaultView": "ボールトの表示",
    "pages": "ページ",
    "table": "表",
    "pagesMarkedUnassignedKeepTheirPrevious": "「未割り当て」としたページは、以前のフィールドを保持します。コレクションを選ぶには、ページを編集してください。",
    "filterPages": "ページを絞り込み",
    "filterPages2": "ページを絞り込み…",
    "worldVault": "世界観のボールト",
    "removeCollectionName": "コレクション{{name}}を削除",
    "collectionSettingsForName": "{{name}}のコレクション設定",
    "iconAndColour": "アイコンと色",
    "newPageInName": "{{name}}に新しいページ",
    "noPageYetAddTheFirst": "ページはまだありません。+で最初のページを追加しましょう。",
    "nothingHereYet": "ここにはまだ何もありません。",
    "removeEmptyCollection": "空のコレクションを削除しますか？",
    "removeNameAndItsSchema": "「{{name}}」とそのスキーマを削除しますか？",
    "removeCollection": "コレクションを削除",
    "text": "テキスト",
    "theSvgMustBeUnder16": "SVGは16KiB未満にしてください。",
    "thisFileIsNotAUsable": "このファイルは使えるSVGではありません（スクリプトと外部参照は削除されます。ルートは<svg>である必要があります）。",
    "collectionName": "コレクション：{{name}}",
    "sharedFieldsApplyToEveryPage": "共有フィールドは、このコレクションのすべてのページに適用されます。各ページは、独自のフィールドも持てます。",
    "cancel": "キャンセル",
    "saving": "保存中…",
    "saveCollection": "コレクションを保存",
    "createCollection": "コレクションを作成",
    "identity": "基本情報",
    "nameAndIconAsTheTree": "ツリーとページに表示される名前とアイコン。",
    "name": "名前",
    "collectionName2": "コレクション名",
    "magic": "魔法",
    "aCollectionWithThisNameAlready": "この名前のコレクションはすでにあります。",
    "icon": "アイコン",
    "iconSource": "アイコンの出所",
    "lucide181": "Lucide（181）",
    "yourSvg": "自分のSVG",
    "collectionIcon": "コレクションのアイコン",
    "searchLucideIcons": "Lucideのアイコンを検索",
    "searchIconsCastleSwordMoon": "アイコンを検索：城、剣、月…",
    "loadingIcons": "アイコンを読み込み中…",
    "lucideIcon": "Lucideのアイコン",
    "noIconMatches": "一致するアイコンはありません。",
    "chooseAnSvgFile": "SVGファイルを選択",
    "customSvgIcon": "カスタムSVGアイコン",
    "upTo16KibScriptsLinks": "16KiBまで。スクリプト、リンク、外部参照は削除されます。コレクションの色を反映するには、ファイル内でcurrentColorを使ってください。",
    "colour": "色",
    "aPresetOneYouUsedRecently": "プリセット、最近使ったもの、またはカラーホイールで自分の色を。",
    "collectionColour": "コレクションの色",
    "recent": "最近使った色",
    "useHex": "{{hex}}を使用",
    "kindOfPage": "ページの種類",
    "everyPageIsACodexEntry": "すべてのページは、一つの種類の設定集の項目です。種類によって、チェック、@の言及、グラフでの扱いが決まり、その色がどこでも保たれます。",
    "collectionBaseKind": "コレクションの基本の種類",
    "magicOrShipsConceptDeitiesOr": "魔法や船 → 概念・神格や家 → キャラクターか勢力・町のコレクション → 場所。",
    "sharedFields": "共有フィールド",
    "thePropertiesOfTheCollectionValues": "コレクションの性質です。値は各ページにあり、ページは独自のものも追加できます。",
    "collectionTemplate": "コレクションのテンプレート",
    "template": "テンプレート…",
    "addField": "フィールドを追加",
    "exampleMagicLevelNumberRarityChoice": "例：魔法 → レベル（数値）・希少度（選択：一般、希少、伝説）・入手（物語内の日付）・教えた人（項目のリンク）。",
    "collectionFieldNameValue": "コレクションのフィールド名{{value}}",
    "fieldName": "フィールド名",
    "collectionFieldTypeValue": "コレクションのフィールドの型{{value}}",
    "collectionFieldOptionsValue": "コレクションのフィールドの選択肢{{value}}",
    "optionsOnePerLine": "選択肢（1行に1つ）",
    "required": "必須",
    "requiredCollectionFieldValue": "必須のコレクションフィールド{{value}}",
    "removeCollectionFieldValue": "コレクションのフィールド{{value}}を削除",
    "yesNo": "はい／いいえ",
    "multipleChoice": "複数選択",
    "storyDate": "物語内の日付",
    "entryLink": "項目のリンク",
    "multipleEntryLinks": "複数の項目のリンク",
    "fieldParagraph": "段落",
    "fieldNumber": "数値",
    "fieldChoice": "選択肢"
  },
  "worldCloudPanel": {
    "worldCloudVersions": "世界観のクラウドバージョン",
    "includesCodexPagesCollectionsFoldersFacts": "設定集のページ、コレクション、フォルダー、事実、関係、添付を含みます。バージョンは明示的に公開またはダウンロードします。原稿はシーンの同期を使います。",
    "compareVersions": "バージョンを比較",
    "recoverPreviousWorld": "以前の世界観を復旧…",
    "deviceRevision": "端末のリビジョン",
    "accountVersionRemoteversion": "アカウントのバージョン{{remoteVersion}}",
    "firstAccountVersion": "アカウントの最初のバージョン",
    "uploadDeviceVersion": "端末のバージョンをアップロード…",
    "useAccountVersion": "アカウントのバージョンを使う…",
    "confirmTransfer": "転送を確認",
    "replaceWorldOnThisDeviceWith": "この端末の世界観を、このバージョンで置き換えますか？現在の世界観と添付のコピーが、先に保持されます。原稿のテキストは変更されません。",
    "saveThisCopyToYourAccount": "このコピーをアカウントに保存しますか？以前のアカウントのバージョンは保持されます。",
    "restoreWorldFromBeforeTheLast": "最後の転送より前の世界観を復元しますか？その後に編集があると、この復元はできません。",
    "confirm": "確認",
    "cancel": "キャンセル",
    "transferring": "転送中…",
    "codexPages": "設定集のページ",
    "updateStoryideBeforePublishingChangesTo": "このボールトに変更を公開する前に、Musaelを更新してください。",
    "theAccountVersionChangedCompareAgain": "アカウントのバージョンが変更されました。適用する前に、もう一度比較してください。",
    "worldChangedOnThisDeviceCompare": "この端末で世界観が変更されました。適用する前に、もう一度比較してください。",
    "accountVersionStorageIsFullPrevious": "アカウントのバージョンの保存容量がいっぱいです。以前のコピーは保持されます。",
    "anAttachmentFailedItsIntegrityCheck": "添付の整合性チェックに失敗しました。ローカルのコピーは置き換えられていません。",
    "theAccountCopyFailedItsIntegrity": "アカウントのコピーの整合性チェックに失敗しました。",
    "noRecoveryCopyIsAvailableFor": "この転送に使える復旧用コピーがありません。",
    "anIdentifierIsAlreadyUsedIn": "識別子が、別のプロジェクトですでに使われています。",
    "openOrSyncTheManuscriptWith": "先に原稿を開くか、アカウントと同期してください。",
    "yourAccountDoesNotHaveThe": "アカウントに、必要な権限がありません。",
    "signInAgainThisSessionWas": "もう一度サインインしてください。このセッションは取り消されました。",
    "transferCancelled": "転送をキャンセルしました。",
    "transferFailedCheckYourConnectionAnd": "転送に失敗しました。接続を確認して、もう一度比較してください。",
    "couldNotReadTheRecoveryCopy": "復旧用コピーを読み取れませんでした。",
    "mondoPrecedenteRipristinato": "以前の世界観を復元しました。",
    "accountVersionVersionSaved": "アカウントのバージョン{{version}}を保存しました。",
    "versionVersionAppliedToWorldOn": "バージョン{{version}}を、この端末の世界観に適用しました。",
    "cancellationRequested": "キャンセルをリクエストしました。",
    "labelFacts": "事実",
    "labelEvents": "出来事",
    "labelKnowledge": "知識",
    "labelAnnotations": "注釈",
    "labelRelationships": "関係",
    "labelAttachments": "添付",
    "labelCollections": "コレクション",
    "labelFolders": "フォルダー",
    "changedCount_other": "{{count}}件変更"
  },
  "worldMaps": {
    "character": "キャラクター",
    "place": "場所",
    "object": "物",
    "faction": "勢力",
    "concept": "概念",
    "pinOf": "ピン：{{name}}",
    "pinMissing": "欠けている項目のピン",
    "missingEntry": "欠けている項目",
    "zoom": "ズーム",
    "zoomIn": "拡大",
    "zoomOut": "縮小",
    "fitToView": "全体を表示",
    "newMap": "新しい地図",
    "newMapDescription": "場所の画像。そこにある人、場所、ものにピンを立てられます。",
    "cancel": "キャンセル",
    "saving": "保存中…",
    "createMap": "地図を作成",
    "mapOf": "地図：",
    "aNewPlace": "新しい場所",
    "placeName": "場所の名前",
    "placeNamePlaceholder": "The Salt Coast",
    "picture": "画像",
    "choosePicture": "PNG、JPEG、WebP、GIFを選択",
    "pictureHint": "16MBまで。項目の添付の一つになります。",
    "maps": "地図",
    "mapsLead": "場所の画像に、項目のピンを立てましょう。独自の地図を持つ場所のピンからは、その地図が開きます。",
    "noMapsYet": "地図はまだありません",
    "noMapsText": "場所に画像を与え、そこに属する項目をピンで留めましょう。",
    "addTheFirstMap": "最初の地図を追加",
    "onePin": "ピン1個",
    "pins": "ピン{{count}}個",
    "inPlace": "{{place}}上",
    "chooseAnEntryOrName": "項目を選ぶか、ピンの名前を書いてください。",
    "mapTrail": "この地図の上位の地図",
    "doneAdding": "完了",
    "addPin": "ピンを追加",
    "labels": "ラベル",
    "replacePicture": "画像を置き換え",
    "removeMap": "地図を削除",
    "hintClick": "ピンを置く位置で、地図をクリックしてください。",
    "hintChoose": "ピンが指すものを、右で選んでください。",
    "pictureMissing": "この地図の画像は、まだこの端末にありません。",
    "pinDetails": "ピンの詳細",
    "newPin": "新しいピン",
    "entry": "項目",
    "chooseAnEntry": "項目を選択",
    "noEntryLabelOnly": "項目なし、ラベルのみ",
    "labelOnTheMap": "地図上のラベル",
    "labelDefault": "項目の名前",
    "labelRequired": "項目がない場合は必須",
    "placePin": "ピンを置く",
    "label": "ラベル",
    "openEntry": "項目を開く",
    "openItsMap": "その地図を開く",
    "position": "左から{{x}}%、上から{{y}}%",
    "removePin": "ピンを削除",
    "noPinsYet": "ピンはまだありません。「ピンを追加」を使ってから、地図をクリックしてください。",
    "shownOn": "表示先",
    "openEntryOf": "{{name}}を開く",
    "removeMapTitle": "{{name}}の地図を削除しますか？",
    "removeMapMessage": "ピンも一緒に削除されます。画像は、項目の添付に残ります。"
  },
  "worldPanel": {
    "checks": "チェック",
    "findAndFixConsistencyIssuesIn": "世界観の事実、出来事、関係を原稿と照らし合わせます。AIは使いません。",
    "running": "実行中…",
    "runChecks": "チェックを実行",
    "lastRunAt": "最終実行：{{time}}",
    "oneAtATime": "一度に一つ",
    "exclusiveRelation": "排他的な関係",
    "noRelationIsExclusive": "排他的な関係はありません",
    "exclusivityType": "排他性の種類",
    "oneSourcePerTarget": "各対象に一つの起点",
    "oneTargetPerSource": "各起点に一つの対象",
    "oneAtATimeHint": "同時に一つにしか成り立たない関係、たとえば「所有する」：同じものの二人の所有者が同じ時点にいると、競合になります。",
    "rulesNeedRelations": "ルールはあなたの関係を使います。「所有する」のような関係を接続で追加し、ここで排他的にしてください。",
    "results": "結果",
    "whatTheChecksLookFor": "チェックが探すもの",
    "twoHoldersAtOnce": "同時の二人の保有者",
    "eventsOutOfOrder": "順序が入れ替わった出来事",
    "quotedPastItsLimit": "上限を超えて引用",
    "linksToDeletedEntries": "削除された項目へのリンク",
    "notesThatLostTheirPlace": "位置を失ったノート",
    "relationsOverTime": "時間経過での関係",
    "scopeOwnership": "確認済みの事実にもとづき、同じ時点に二つの項目が一つのものを保有している。",
    "scopeFlashback": "世界の中でより後に起きる出来事の後に読まれる出来事：回想、または手違い。",
    "scopeReveal": "許可した最後のシーンより後のシーンで引用された事実。",
    "scopeOrphans": "もう存在しない項目やライブラリのカードを指すノートと事実。",
    "scopeAnchors": "引用された箇所の語が、シーン内で動いたか、変わった。",
    "scopeRelations": "上のルールと、それらが引く引用に照らした関係。",
    "filterResults": "結果を絞り込み",
    "all": "すべて",
    "conflicts": "競合",
    "warnings": "警告",
    "needsData": "データ不足",
    "noIssuesFound": "問題は見つかりませんでした",
    "theExecutedRulesFoundNoViolation": "設定した事実とルールに反するものはありません。チェックは、記録されたことしか知りません。",
    "notEnoughData": "データが足りません",
    "quotesInTheText": "本文中の引用",
    "anchorInPlace": "所定の位置",
    "anchorMoved": "移動",
    "anchorGone": "なくなった",
    "reAnchor": "再固定",
    "openScene": "シーンを開く",
    "checkedAt": "{{time}}に確認しました。",
    "twoHold": "{{a}}と{{b}}が、どちらも「{{object}}」を同時に保有しています。",
    "heldTwice": "{{a}}が、同じ時点に「{{object}}」を二重に保有しています。",
    "flashbackSentence": "世界の中では「{{earlier}}」が「{{later}}」より前に起きますが、後に読まれます。回想であれば問題ありませんが、意図しないなら見直してください。",
    "revealSentence": "「{{fact}}」が{{scene}}で引用されていますが、許可した最後のシーンより後です。",
    "allowedUpToScene": "シーン{{scene}}まで許可",
    "orphanFactSentence": "事実（「{{fact}}」）が、削除された項目に関するものです。",
    "orphanNoteSentence": "「{{excerpt}}」のノートが、削除された項目を指しています。",
    "orphanConceptSentence": "「{{excerpt}}」のノートが、もう存在しないライブラリのカードを指しています。",
    "movedSentence": "「{{excerpt}}」が{{scene}}の中で動きました。ノートを再固定して追従させてください。",
    "eventWithoutTime": "「{{title}}」は世界の中の時間がないため、順序を確認できません。",
    "factWithoutTime": "「{{fact}}」には期間がないため、その保有者を確認できません。",
    "recordWithoutTime": "記録に時間がないため、確認できません。",
    "aDeletedEntry": "削除された項目",
    "aDeletedEvent": "削除された出来事",
    "aScene": "シーン",
    "fromTo": "{{start}}から{{end}}まで",
    "relativeToAnEvent": "出来事に対する相対",
    "timeNotSet": "未設定",
    "facts": "事実",
    "factsLead": "各項目について述べること。チェックは、あなたが確認したものを読み、原稿と照らし合わせます。",
    "entries": "項目",
    "addAnEntry": "項目を追加",
    "addTheFirstEntry": "最初の項目を追加",
    "newEntityName": "新しい項目の名前",
    "entityType": "項目の種類",
    "addEntity": "項目を追加",
    "character": "キャラクター",
    "place": "場所",
    "object": "物",
    "faction": "勢力",
    "other": "その他",
    "deleteEntityReferencesBecomeOrphaned": "項目を削除（参照は孤立します）",
    "deleteEntityName": "項目{{name}}を削除",
    "noFactYet": "{{name}}についての事実はまだありません。新しい事実は「提案済み」で始まります。確認すると有効になります。",
    "proposed": "提案済み",
    "confirmed": "確認済み",
    "rejected": "却下",
    "superseded": "置き換え済み",
    "worldFact": "世界の事実",
    "characterBelief": "信念",
    "testimony": "証言",
    "authorHypothesis": "仮説",
    "confirm": "確認",
    "confirmExplicitApproval": "確認（明示的な承認）",
    "newFactAbout": "{{name}}についての新しい事実",
    "predicatePlaceholder": "所有する",
    "predicate": "述語",
    "valuePlaceholder": "剣",
    "value": "値",
    "kind": "種類",
    "epistemicKind": "認識論的な種類",
    "kindHint": "世界の事実だけが真実として扱われます。信念、証言、仮説は保持されますが、正史としてはチェックされません。",
    "when": "いつ",
    "timeKind": "時間の種類",
    "betweenTwoMoments": "二つの時点の間",
    "from": "開始：",
    "to": "〜",
    "startTick": "開始ティック",
    "endTick": "終了ティック",
    "momentsHint": "世界の年表上の時点。終了は含まれません。",
    "reveal": "明かされる時点",
    "maximumRevealNarrativeIndex": "最大の開示（物語上の位置）",
    "noLimit": "上限なし",
    "sceneNumbered": "{{n}}. {{title}}",
    "revealHint": "この事実を後のシーンで引用すると、警告されます。",
    "addFactProposed": "提案済みとして追加",
    "selectAnEntityToSeeAnd": "項目を選ぶと、その事実を見たり追加したりできます。",
    "noEntityYet": "項目はまだありません。上、または設定集で、キャラクター、場所、物を追加してください。",
    "resultDetails": "結果の詳細",
    "conflict": "競合",
    "warning": "警告",
    "whatWasCompared": "比較したもの",
    "whatToDo": "対処",
    "comparedOwnership": "期間を持つ確認済みの世界の事実。同じものの二人の保有者は、重なってはいけません。",
    "comparedFlashback": "各出来事の世界の中の時間と、本の中のシーンの順序。",
    "comparedReveal": "事実に許可した最後のシーンと、それを引用するシーン。",
    "comparedOrphans": "すべてのノートと事実と、存在する項目とライブラリのカード。",
    "comparedAnchors": "各ノートの引用と、シーンの現在のテキスト。",
    "confirmOnlyOneOwnerInThe": "その時点の保有者を一人にしてください。期間の一つを狭めるか、事実の一つを「提案済み」に戻します。",
    "ifTheSceneIsADeliberate": "そのシーンが意図した回想なら、そのままにしてください。そうでなければ、シーンを動かすか、出来事の時間を変えてください。",
    "raiseTheMaximumRevealSceneOf": "その事実に後のシーンを許可するか、引用を前に動かしてください。",
    "restoreTheMissingEntityFromThe": "設定集の履歴から項目を復元するか、それを指しているノートや事実を削除してください。",
    "useReAnchorManualOnThe": "結果の引用で「再固定」を使うか、シーンを開いて、もう一度箇所を選択してください。",
    "giveTheEventOrFactAn": "世界の中の時間を与えるか、与えないでおいてください。推測で警告を出すことはありません。",
    "selectAResult": "結果を選択",
    "detailsConstraintsAndSuggestedFixesAppear": "比較したものと、対処がここに表示されます。",
    "thisAnnotationCannotBeReAnchored": "このノートは再固定できません。「{{excerpt}}」がシーンにないか、複数回出現しています。",
    "revisionTools": "推敲ツール",
    "loadingRevisionTools": "推敲ツールを読み込み中…"
  },
  "worldReplicationPanel": {
    "theContentChangedWhileItWas": "確認している間に内容が変更されました。確認した内容と承認を選んでください。",
    "theseChangesCannotBeCombinedInto": "これらの変更は、有効な世界観に結合できません。保持する完全なバージョンを選んでください。両方のコピーは復旧用に残ります。",
    "thisDevice": "この端末",
    "yourAccount": "あなたのアカウント",
    "viewWorld": "世界観を表示",
    "previousSharedValue": "以前の共有の値",
    "theActionCouldNotFinishYour": "操作を完了できませんでした。ローカルの変更は保持されています。",
    "worldSync": "世界観の同期",
    "syncCodexPagesFactsTimelinesCollections": "設定集のページ、事実、年表、コレクション、添付を端末間で同期します。ノートとスケッチは、下で別に同期されます。",
    "syncWorldAutomatically": "世界観を自動的に同期",
    "n1PendingChange": "保留中の変更1件",
    "pendingPendingChanges": "保留中の変更{{pending}}件",
    "syncNow": "今すぐ同期",
    "exportRecoveryCopies": "復旧用コピーを書き出し",
    "compareBeforeSyncing": "同期前に比較",
    "signInToTheLinkedAccount": "同期するには、連携したアカウントにサインインしてください。ローカルの変更は保存されたままです。",
    "signInToCompareYourWorld": "世界観を比較して同期を有効にするには、サインインしてください。",
    "chooseYourStartingWorld": "出発点の世界観を選択",
    "bothCopiesHaveTheSameContent": "両方のコピーの内容は同じです。",
    "keepTheWorldOnThisDevice": "この端末の世界観を保持するか、アカウントのコピーを使います。以前のローカルの世界観と添付は、復旧用に保持されます。",
    "keepThisDeviceSync": "この端末を保持して同期",
    "useAccountCopySync": "アカウントのコピーを使って同期",
    "cancel": "キャンセル",
    "reviewConcurrentChanges": "同時の変更を確認",
    "chooseEachValueToKeepOther": "保持する値をそれぞれ選んでください。ほかの変更は自動的に統合されます。両方のバージョンは復旧可能なままです。",
    "applyReviewedChoices": "確認した選択を適用",
    "syncingWorldAndAttachments": "世界観と添付を同期中…",
    "codexPages": "設定集のページ",
    "onThisDevice": "この端末",
    "waitingToSync": "同期待ち",
    "syncing": "同期中…",
    "upToDate": "最新の状態",
    "reviewNeeded": "確認が必要",
    "emptyText": "（空のテキスト）",
    "emptyList": "（空のリスト）",
    "worldStructure": "世界観の構造",
    "labelFacts": "事実",
    "labelEvents": "出来事",
    "labelKnowledge": "知識",
    "labelAnnotations": "注釈",
    "labelRelationships": "関係",
    "labelAttachments": "添付",
    "labelCollections": "コレクション",
    "labelFolders": "フォルダー",
    "paused": "一時停止中",
    "addedCount_other": "{{count}}件追加",
    "removedCount_other": "{{count}}件削除",
    "changedCount_other": "{{count}}件変更",
    "removedValue": "削除済み",
    "emptyValue": "空"
  },
  "worldReviewTools": {
    "deletedEntry": "削除された項目",
    "timeUnknown": "時間不明",
    "storyTimeInterval": "物語内の時間の区間",
    "relativeToEventPreserved": "出来事に対する相対（保持）",
    "from": "開始：",
    "until": "終了：",
    "characterKnowledge": "キャラクターの知識",
    "couldNotCheckTheSavedManuscriptRetry": "保存済みの原稿を確認できませんでした。再試行してください。",
    "revisionTools": "推敲ツール",
    "changeImpact": "変更の影響",
    "whatPointsToThisRecord": "この記録を指しているものは？",
    "explicitLinksOnlyIncludingIndirectLinksChangingARecord": "間接的なリンクを含め、明示的なリンクのみ。記録を変更しても、それに依存するものは書き換えられません。",
    "impactRecord": "影響を調べる記録",
    "chooseARecord": "記録を選択",
    "linkedRecordsWorldRevision": "件のリンクされた記録・世界観のリビジョン",
    "directLink": "直接のリンク",
    "missingSourceScene": "元のシーンが見つかりません",
    "noExplicitRecordLinksToThisEntryUnlinkedProse": "この項目への明示的な記録リンクはありません。リンクされていない文章は、このチェックの対象外です。",
    "whenDidTheyLearnIt": "いつ知ったのか？",
    "recordAcquisitionAndUseOnTheSameStoryTime": "取得と使用を、同じ物語内の時間軸に記録します。推測と信念は別に保たれ、章の順序が物語内の時間として扱われることはありません。",
    "recordKnowledge": "知識を記録",
    "couldNotSaveCheckTheIntervalsOrCancelAnd": "保存できませんでした。区間を確認するか、世界観が変更された場合はキャンセルして開き直してください。",
    "character": "キャラクター",
    "knowledgeCharacter": "知識を持つキャラクター",
    "chooseACharacter": "キャラクターを選択",
    "fact": "事実",
    "knowledgeFact": "知識の事実",
    "chooseAConfirmedWorldFact": "確認済みの世界の事実を選択",
    "acquired": "取得",
    "acquisitionSource": "取得の出典",
    "noSourceAttached": "出典なし",
    "use": "使用",
    "scene": "シーン",
    "chooseAScene": "シーンを選択",
    "knownInformation": "既知の情報",
    "belief": "信念",
    "guess": "推測",
    "passageSource": "箇所の出典",
    "noPassageAttached": "箇所なし",
    "removeUse": "使用を削除",
    "addUse": "使用を追加",
    "confirmAndSave": "確認して保存",
    "cancel": "キャンセル",
    "missingFact": "欠けている事実",
    "atUnknownRelativeTime": "不明または相対的な時点で",
    "edit": "編集",
    "couldNotRemoveTheRecordRefreshAndRetry": "記録を削除できませんでした。更新して再試行してください。",
    "checkSavedKnowledge": "保存済みの知識をチェック",
    "theWorldChangedSinceThisResultRunTheCheck": "この結果の後に世界観が変更されました。チェックをもう一度実行してください。",
    "recordedUseIsEarlierThanAcquisition": "記録された使用が、取得より前になっています",
    "recordedTimesAreInOrder": "記録された時間は順序どおりです",
    "beliefOrGuessNotAKnowledgeConflict": "信念または推測：知識の競合ではありません",
    "notEnoughInformationToCompare": "比較するための情報が足りません",
    "attachedPassagesMatchTheSavedText": "添付された箇所は、保存済みのテキストと一致しています",
    "aSourceIsMissingStaleOrBelongsToAnother": "出典が欠けているか、古いか、別のシーンのものです",
    "authorRecordedTimesPassagesAreNotVerified": "作者が記録した時間です。箇所は検証されていません",
    "openScene": "シーンを開く",
    "noConfirmedKnowledgeUsesToCompare": "比較できる確認済みの知識の使用がありません。",
    "openNamedScene": "{{title}}を開く",
    "recordSummary": "使用：{{count}}・{{lifecycle}}・取得{{time}}",
    "checkSummary": "{{time}}に確認・記録された使用{{count}}件。文章を編集した後は更新してください。",
    "resultsLimitedTo500Records": "結果は500件までに制限されています",
    "linksAway": "リンク{{depth}}つ先",
    "useNKind": "用途{{n}}の種類",
    "useN": "用途{{n}}",
    "useNSource": "用途{{n}}のソース",
    "checking": "確認中…"
  },
  "worldSection": {
    "overview": "概要",
    "vault": "ボールト",
    "timeline": "年表",
    "connections": "接続",
    "references": "参照",
    "checks": "チェック",
    "analysis": "分析",
    "characters": "キャラクター",
    "locations": "場所",
    "factions": "勢力",
    "objects": "物",
    "concepts": "概念",
    "worldViews": "世界のビュー",
    "world": "世界観",
    "browseByType": "種類で閲覧",
    "filterByType": "種類で絞り込み",
    "all": "すべて",
    "newEntry": "新しい項目",
    "cercaNelCodex": "設定集を検索",
    "searchEntries": "項目を検索…",
    "entry": "項目",
    "entries": "項目",
    "alsoAliases": "別名：{{aliases}}",
    "noEntriesYetCreateTheFirst": "項目はまだありません。最初のキャラクター、場所、勢力を作成しましょう。",
    "noEntryMatches": "一致する項目はありません。",
    "editName": "{{name}}を編集",
    "edit": "編集",
    "archive": "アーカイブ",
    "confirmArchive": "アーカイブを確認",
    "notesAndSketches": "ノートとスケッチ",
    "alsoKnownAs": "別名",
    "addADescriptionOneLineThat": "説明を追加してください。これが何かを一行で。",
    "none": "なし",
    "yes": "はい",
    "no": "いいえ",
    "removedEntry": "削除された項目",
    "unavailableEntry": "利用できない項目",
    "noNotesYetEditTheEntry": "ノートはまだありません。項目を編集して説明を書いてください。",
    "linkedScenes": "リンクされたシーン",
    "showTheEntriesOfABook": "本ごとの項目を表示",
    "allBooks": "すべての本",
    "bookLine": "第{{number}}巻・{{title}}",
    "inNoBookYet": "まだどの本にもなし",
    "scenesThatMentionThisEntryBy": "この項目を名前や別名で言及しているシーンが、ここに表示されます。",
    "facts": "事実",
    "noFactRecordedFactsAreAdded": "記録された事実はありません。事実は、チェックで追加して承認します。",
    "relations": "関係",
    "noRelationYet": "関係はまだありません。",
    "proposed": " ・提案済み",
    "viewAll": "すべて表示",
    "attachments": "添付",
    "attachAnImageToUseIt": "画像を添付すると、肖像として使えます。",
    "kib": "KiB",
    "open": "開く",
    "remove": "削除",
    "addAttachment": "添付を追加",
    "stateAtStoryTime": "物語内の時間での状態",
    "tick": "ティック",
    "factsWithoutACompleteInterval": "件の事実は、区間が完全ではありません。",
    "selectAnEntry": "項目を選択",
    "charactersPlacesFactionsAndObjectsLive": "キャラクター、場所、勢力、物は、その事実、関係、添付とともにここにあります。",
    "recentChanges": "最近の変更",
    "undoChange": "変更を元に戻す",
    "worldTimeline": "世界の年表",
    "eventsPeopleAndPlacesInA": "より大きな文脈の中の、出来事、人、場所。",
    "noEventYet": "出来事はまだありません",
    "addTheFirstEventWithA": "物語内の時間つきで最初の出来事を追加するか、わかるまで時間を不明にしておきましょう。",
    "tick2": "ティック",
    "plotEvent": "筋書きの出来事",
    "worldEvent": "世界の出来事",
    "openScene": "シーンを開く",
    "unknownTime": "時間不明",
    "unknown": "不明",
    "seeHowYourWorldSPeople": "世界の人、場所、アイデアがどうつながっているかを見渡しましょう。",
    "connectionsView": "接続のビュー",
    "graph": "グラフ",
    "list": "リスト",
    "nothingToConnectYet": "つなぐものはまだありません",
    "createEntriesInTheCodexAnd": "設定集に項目を作成し、リストビューで関係づけましょう。",
    "selectedEntry": "選択中の項目",
    "relationSummary": "関係の概要",
    "noSceneMentionsThisEntryYet": "この項目に言及しているシーンはまだありません。",
    "openInCodex": "設定集で開く",
    "selectANodeToSeeIts": "ノードを選ぶと、その関係とシーンが表示されます。",
    "annotationsAnchoredInTheManuscriptAnd": "原稿に固定された注釈と、世界観のために保管しているファイル。",
    "addFile": "ファイルを追加",
    "annotations": "注釈",
    "selectTextInTheManuscriptAnd": "原稿のテキストを選び、「注釈」で、技法、項目、ノートを固定します。",
    "scene": "シーン",
    "device": "技法",
    "entity": "項目",
    "note": "ノート",
    "imagesPdfsNotesAndAudioYou": "世界観や項目に添付する、画像、PDF、ノート、音声。",
    "linked": "リンク済み",
    "orphan": "孤立",
    "openFile": "ファイルを開く",
    "referenceDetails": "参照の詳細",
    "textAnnotation": "テキストの注釈",
    "kind": "種類",
    "anchor": "固定",
    "concept": "概念",
    "created": "作成日",
    "anchorStatesValidStaleOrphanedAnd": "固定の状態（有効、古い、孤立）と再固定は、チェックで計算されます。",
    "attachment": "添付",
    "type": "種類",
    "size": "サイズ",
    "linkedTo": "リンク先",
    "added": "追加日",
    "confirmRemove": "削除を確認",
    "selectAnAnnotationOrAFile": "注釈またはファイルを選択してください。",
    "exploreTheShapeOfYourStory": "物語の形を探ります：長さ、登場、シーンごとの密度。",
    "sceneLength": "シーンの長さ",
    "wordsPerScene": "シーンごとの語数",
    "noScenesYet": "シーンはまだありません。",
    "titleFmtWords": "{{title}}：{{fmt}}語",
    "entityDensity": "項目の密度",
    "codexMentionsPerScene": "シーンごとの設定集の言及",
    "titleMentionsMentions": "{{title}}：言及{{mentions}}件",
    "characterAppearanceMap": "キャラクターの登場マップ",
    "aDotWhereACharacterIs": "シーンでキャラクターが名前を挙げられている場所に点",
    "addCharactersToTheCodexAnd": "設定集にキャラクターを追加し、シーンでその名前を書きましょう。",
    "thisScene": "このシーン",
    "words": "語数",
    "paragraphs": "段落",
    "sentencesEst": "文数（推定）",
    "distinctWords": "異なる語",
    "annotatedDevices": "注釈つきの技法",
    "n1000Words": "／1,000語",
    "repetitions": "繰り返し",
    "exportHtml": "HTMLで書き出し",
    "exportTxt": "TXTで書き出し",
    "events": "出来事",
    "confirmedFacts": "確認済みの事実",
    "recentlyChanged": "最近変更",
    "changesToTheWorldWillBe": "世界観の変更は、それぞれ元に戻すボタンとともに、ここに一覧されます。",
    "undo": "元に戻す",
    "startHere": "ここから始めましょう",
    "overviewEmptyLead": "物語の人、場所、出来事を、登場するシーンにリンクします。",
    "addACharacter": "キャラクターを追加",
    "addACharacterText": "どんな人物か、何を望むか、何が行く手を阻むか。",
    "addAPlace": "場所を追加",
    "addAPlaceText": "シーンが起きる場所：都市、船、一つの部屋。",
    "addAnEventText": "物語で起きること。日付ありでも、なしでも。",
    "inThisWorld": "この世界で",
    "createAnEntry": "項目を作成",
    "aCharacterAPlaceAFaction": "キャラクター、場所、勢力、物、または概念。",
    "addAnEvent": "出来事を追加",
    "withAnExactStoryTimeOr": "正確な物語内の時間でも、不明でも。",
    "runTheChecks": "チェックを実行",
    "deterministicRulesOwnershipOrderAnchorsOrphans": "保有者、順序、開示、時間経過での関係を、本文と照らし合わせます。",
    "loadingTheWorld": "世界観を読み込み中…",
    "maps": "地図",
    "openItsMap": "その地図を開く",
    "addAMap": "地図を追加",
    "pinnedOn": "固定先：",
    "typeCharacter": "キャラクター",
    "typeLocation": "場所",
    "typeObject": "物",
    "typeFaction": "勢力",
    "typeConcept": "概念",
    "annotationsToReAnchor_other": "再固定が必要な注釈: {{count}}件。"
  }
}
